const { io } = require('socket.io-client')

const socket = io(process.env.REACT_APP_API_BASE_URL, {
  transports: ['websocket']
})

socket.on('connect_error', () => {
  socket.io.opts.transports = ['polling', 'websocket']
})
export default socket
